import React from "react";
import { useTranslation } from "react-i18next";
import RoundButton from "../../Buttons/RoundButton";
import classes from "./SmartGameCard.module.scss";

export default function SmartGameCard({
  className = "",
  id = "",
  name = "",
  image = "",
  abilities = null,
  onClick = null,
  onClickJump = null,
  showOnClickJump = false,
  isLoadingJump = false
}: {
  abilities: any;
  name: string | null;
  image: string | null;
  className?: string;
  id: string;
  onClick: any;
  onClickJump: any | null;
  showOnClickJump: any | null;
  isLoadingJump: boolean;
}) {
  const { t } = useTranslation();
  className += "  " + classes.SmartGameCard;
  return (
    <article className={className} key={id}>
      <div
        className={classes.GameImg}
        style={{ backgroundImage: `url(${image})` }}
      />
      <div className={classes.GameInfos}>
        <h1 className={classes.Title}>{name}</h1>
        <h2 className={classes.SubTitle}>{t("global.you_will_training")}:</h2>
        <ul>
          {abilities &&
            abilities.map((ability: string) => (
              <li className={classes.Info} key={ability}>
                - {ability}
              </li>
            ))}
        </ul>
        <div className={classes.BtnsArea}>
          {showOnClickJump && <div>
            <RoundButton
              extraSmall
              outline={true}
              disabled={isLoadingJump}
              text={t("global.another_game")}
              title={t("global.open_game_modal")}
              onClick={onClickJump}
            />
          </div>}
          <div>
            <RoundButton
              extraSmall
              text={t("global.play")}
              title={t("global.open_game_modal")}
              onClick={onClick}
            />
          </div>
        </div>
      </div>
    </article>
  );
}
